import { isSystemManagedAccount } from "@common/types/domains/accounting/account";
import { ExtendedAccount } from "@common/types/reports/types";

export const SYSTEM_ROLE_BLOCK_REASON = "Account has a system role";

const SCHEDULE_REFERENCE_BLOCK_REASON =
    "Account is used by a recognition policy";

export const getArchiveBlockReason = (
    account: ExtendedAccount,
): string | null => {
    if (account.hasScheduleReferences) {
        return SCHEDULE_REFERENCE_BLOCK_REASON;
    }
    if (isSystemManagedAccount(account)) {
        return SYSTEM_ROLE_BLOCK_REASON;
    }
    if (account.financialAccountId) {
        return "Account is linked to a financial account";
    }
    return null;
};

export const getDeleteBlockReason = (
    account: ExtendedAccount,
): string | null => {
    const archiveBlockReason = getArchiveBlockReason(account);
    if (archiveBlockReason) {
        return archiveBlockReason;
    }
    if (account.credit || account.debit) {
        return "Account has balance";
    }
    return null;
};

export const getMergeBlockReason = (
    account: ExtendedAccount,
): string | null => {
    if (account.hasScheduleReferences) {
        return SCHEDULE_REFERENCE_BLOCK_REASON;
    }
    if (account.financialAccountId) {
        return "Financial accounts cannot be merged here";
    }
    if (account.isDisabled) {
        return "Account is archived and cannot be merged";
    }
    return null;
};

// Target-side blockers (locked period, opening balance, class) are checked in
// the merge modal after the user picks a target.
export const canOfferMergeAfterReassign = ({
    sourceAccount,
}: {
    sourceAccount: ExtendedAccount;
}): boolean => getMergeBlockReason(sourceAccount) === null;
